import React from 'react';
import PropTypes from 'prop-types';

import Slot from '../Slot';
import { Layout } from '../styles';

const HalfAndHalf = ({ slot }) => {
	return (
		<Layout>
			<Slot
				top={5}
				left={5}
				width={42.5}
				height={90}
				component={slot[0].type}
				data={slot[0].data}
				layout={slot[0].layout}
			/>
			<Slot
				top={5}
				left={52.5}
				width={42.5}
				height={90}
				component={slot[1].type}
				data={slot[1].data}
				layout={slot[1].layout}
			/>
		</Layout>
	)
}

HalfAndHalf.defaultProps = {
	slot: []
}

HalfAndHalf.propTypes = {
	slot: PropTypes.array,
}

export default HalfAndHalf
